import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Configuration } from '../../shared/services/configuration';
import { HttpClientCustom } from '../../shared/services/http.client';
import * as _ from 'underscore';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Auth } from '../../shared/services/auth';
import { RouterModule, Router } from '@angular/router';
import { Location } from '@angular/common';
import { SharedData } from '../../shared/sharedData';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { ConfirmationComponent } from '../../confirmation/confirmation';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'Roles-Permission',
  templateUrl: 'rolesAndPermission.html',
})
export class RolesAndPermissionComponent {
  public _baseUrl: any;
  public showLoading: any = true;
  //pagination variables  and default values
  public pageSize: any = 10;
  public page = 1;
  public startingPage: any = 1;
  public endingPage: any = 10;
  public collectionSize: any;
  public trackHides = null;
  public roles: any = 1;
  public completeRolesAndPermissionData: any = [];
  public rolePageData: any = [];
  constructor(
    public route: ActivatedRoute,
    public modalService: NgbModal,
    public _global: Configuration,
    public _http: HttpClientCustom,
    public builder: FormBuilder,
    public _auth: Auth,
    public router: Router,
    public _location: Location,
    public share: SharedData,
    public translate:TranslateService,
    public _toaster: ToasterComponent,
    vcr: ViewContainerRef
  ) {
    this._baseUrl = _global.get("EPMS_BASE_URL");
    
    this.getCompleteRolesAndPermissionDetails();
    this._toaster.setViewRef(vcr);
  }

  //pagination functions
  onPageChange(event: number): void {
    let that = this;
    if (event == 1) {
      that.startingPage = 1;
      that.endingPage = 10;
    } else {
      that.startingPage = 1 + that.pageSize;
      if (that.collectionSize > that.endingPage) {
        that.endingPage = event + that.endingPage;
      } else {
        that.endingPage = that.collectionSize;
      }
    }
    that.page = event;
    that.getCompleteRolesAndPermissionDetails();
  }
  OnPageSizeChanged(val) {
    this.pageSize = val;
    this.getCompleteRolesAndPermissionDetails();
  }

  //cal to get all the roles 
  getCompleteRolesAndPermissionDetails() {
    try {
      let that = this;
      let url = that._baseUrl + 'v1/webAdmin/role';
      that._http.put(url, { page: that.page, pageSize: that.pageSize }).subscribe((result) => {
        let self = this;
        self.completeRolesAndPermissionData = result.content;
        self.rolePageData=result;
        if (self.completeRolesAndPermissionData.length == 0) {
          self.showLoading = false;
        }

        self.collectionSize = result.totalElements;
        if (result.last) {
          self.endingPage = self.collectionSize;
        }
      });
    } catch (e) {
      console.log('caught error in getCompleteRolesAndPermissionDetails', e);
    }
  }

  createRoles() {
    try {
      let that = this;
      let url = that._baseUrl + 'v1/webAdmin/role';
      that._http.get(url).subscribe(result => {
        that.share.saveAsMap('roleData', result);
        that.share.saveAsMap('type', 'CREATE');
        that.router.navigate(['/menu/createRoles']);
      });
    } catch (e) {

    }
  }


  clicked() {
    this.trackHides = null;
  }

  //roles actions hide/show and functions
  empTableActions(value) {
    if (this.trackHides == value) {
      this.trackHides = null;
    } else {
      this.trackHides = value;
    }
  }
  editRoles(id) {
    try {
      let that = this;
      that.trackHides = null;
      let url = that._baseUrl + 'v1/webAdmin/role/getEditRoleById' + '?roleId=' + id;;
      that._http.get(url).subscribe((result) => {
        that.share.saveAsMap('roleData', result);
        that.share.saveAsMap('type', 'EDIT');
        that.router.navigate(['/menu/createRoles']);
      });
    } catch (e) {
      console.log('caught in edit Roles', e);
    }
  } 
  addUserRoles(id) {
    this.share.saveData({ id: id, type: 'ADDROLE' });
    this.router.navigate(['/menu/addUsers']);
  }

  removeUserRoles(id) {
    this.share.saveData({ id: id, type: 'DELETEROLE' });
    this.router.navigate(['/menu/addUsers']);
  } 
  viewDetails(id) {
    this.share.saveData(id);
    this.router.navigate(['/menu/EmployeeInRole']);
  }


  deleteUser(id) {
    this.trackHides = null;
    let closeResult: any;
    this.share.saveData(id);
    let confirmData: any = {
      type: 'Delete',
      program: id
    }
    let self = this;
    self.share.saveData(confirmData);
    const modalRef = self.modalService.open(ConfirmationComponent, { windowClass: 'min-modal' }).result.then((result) => {
      closeResult = `Closed with: ${result}`;
      if (result == 'confirmed') {        
        let url = self._baseUrl + 'v1/webAdmin/role' + '?roleId=' + id;
        self._http.delete(url).subscribe((result) => {           
          if(result.success) {            
          self.translate.get('roleDelete').subscribe((msg) => {
            self._toaster.showSuccess(msg);            
            self.onRefresh()
        });     
      }else{         
        self.translate.get('roleCouldNotDelete').subscribe((msg) => {
          self._toaster.showError(msg);
        })
      }  
          
        });
     
      }
    }, (reason) => {
      closeResult = `Dismissed ${reason}`;
    });
  }

  confirmDelete(id) {
    try {
      let that = this;
      let url = that._baseUrl + 'v1/webAdmin/role/getEmployeeInfoByRoleId/' + id;
      that._http.post(url, {}).subscribe(result => {
      });
    } catch (e) {
      console.log('error', e);
    }
  }

  public onRefresh(){
    this.getCompleteRolesAndPermissionDetails();
 
  }
}



// WEBPACK FOOTER //
// ./src/app/tools/rolesAndPermission/rolesAndPermission.ts